import { IconsTypesProps } from '../icons/types';

export const FloatIcon = ({ width = 18, height = 32, fill }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.177" cy="5.94665" r="3.06665" fill="#657289" />
    <path
      d="M5.89648 5.75293H10.3252C11.9052 5.75293 13.2731 6.8119 13.6865 8.31055L13.7568 8.61621L16.4355 23.333C16.8467 25.592 15.8037 27.8587 13.8418 29.0215L13.6494 29.1309C10.8263 30.6543 7.4528 30.7402 4.5625 29.377L4.28418 29.2412L3.96094 29.0762C1.85129 28.001 0.602164 25.7664 0.777344 23.4199L0.798828 23.1924L2.43066 8.8457C2.63128 7.08356 4.12293 5.75293 5.89648 5.75293Z"
      fill={fill}
      stroke="#657289"
      strokeWidth="0.634123"
    />
    <path
      d="M5.76172 28L5.50074 27.9226C4.304 27.5676 3.34948 26.6612 2.93312 25.4844L2.76172 25"
      stroke="#F2F3F5"
      strokeWidth="0.634123"
    />
    <path
      d="M10.0001 7.02332L10.6307 7.06433C11.5366 7.12324 12.2746 7.81399 12.3933 8.71398L12.5 9.52319"
      stroke="#F2F3F5"
      strokeWidth="0.634123"
    />
    <rect x="8" width="1" height="4" fill="#657289" />
  </svg>
);
